import BrandProductsTaxonomyChangeModal from './BrandProducts.TaxonomyChangeModal.Container';

export default BrandProductsTaxonomyChangeModal;
